import React from "react";

import { FilterIcon as Filter } from "@packages/ds";
import { useIntl } from "react-intl";

import * as Dropdown from "ds/Dropdown";
import { Flex } from "src/organization/pages/project/environment/metrics/components/tooltip/style";

import RoundLegend from "../components/RoundLegend";
import { httpStatusOptions } from "../config";

import { statusColorBands } from "./utils";

export type HttpStatusProps = {
  setHttpStatus: (status: string[]) => void;
  httpStatuses: string[];
};

const HttpStatusFilter = (props: HttpStatusProps) => {
  const { setHttpStatus, httpStatuses } = props;
  const handleChange = (status: string) => {
    const isIncluded = httpStatuses.includes(status);
    setHttpStatus(
      isIncluded
        ? props.httpStatuses.filter(s => s !== status)
        : [...httpStatuses, status]
    );
  };

  return (
    <Dropdown.Root id="http.status_codes">
      <Dropdown.Trigger aria-label="http-status-codes">
        <Filter />
      </Dropdown.Trigger>
      <Dropdown.Portal>
        <Dropdown.Content>
          <Dropdown.Label>
            {useIntl().formatMessage({ id: "http.status_codes" })}
          </Dropdown.Label>
          {httpStatusOptions.map(status => (
            <Dropdown.CheckboxItem
              onCheckedChanged={() => handleChange(status)}
              id={status}
              key={status}
              checked={props.httpStatuses.includes(status)}
            >
              <Flex>
                <RoundLegend color={statusColorBands[status]} />
                <span>{status}</span>
              </Flex>
            </Dropdown.CheckboxItem>
          ))}
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
};

export default HttpStatusFilter;
